import styled from 'styled-components'

export const QuestionTitleWrapper = styled.div`
  display: flex;
`
